export enum PlaceholderType {
  input,
  bool,
  list,
  int,
  float,
  text
}

export interface PlaceholderValues {
  Key: string,
  Label: string,
  Type: PlaceholderType,
  Options?: string[],
  DecimalPlaces?: number,
  Nullable: boolean
}

const PlaceholderTypeLabels = {
  [PlaceholderType.input]: 'Input',
  [PlaceholderType.bool]:  'Boolean',
  [PlaceholderType.list]:  'List',
  [PlaceholderType.int]:   'Integer',
  [PlaceholderType.float]: 'Decimal',
  [PlaceholderType.text]:  'Text',
} satisfies Record<PlaceholderType, string>;

const PlaceholderTypeValue = [
  PlaceholderType.input,
  PlaceholderType.bool,
  PlaceholderType.list,
  PlaceholderType.int,
  PlaceholderType.float,
  PlaceholderType.text,
] satisfies readonly PlaceholderType[]; 

export const PlaceholderTypeOptions = PlaceholderTypeValue.map(v => ({
  value: v,
  label: PlaceholderTypeLabels[v],
}));